import type { FunctionComponent } from 'react';

import './style.scss';

type PropsT = {
  color?: string;
  vMargin?: 'bottom' | boolean;
};

const Separator: FunctionComponent<PropsT> = ({ color, vMargin }) => {
  let margin: string | undefined;
  if (vMargin === true) margin = '16px 0';
  else if (vMargin === 'bottom') margin = '0 0 16px';

  return (
    <div
      style={{
        background: color,
        margin,
      }}
      styleName="style"
    />
  );
};

export default Separator;
